import { render, staticRenderFns } from "./ForwardCmd.vue?vue&type=template&id=367ebace&scoped=true"
import script from "./ForwardCmd.vue?vue&type=script&lang=js"
export * from "./ForwardCmd.vue?vue&type=script&lang=js"
import style0 from "./ForwardCmd.vue?vue&type=style&index=0&id=367ebace&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367ebace",
  null
  
)

export default component.exports